import { Component, OnInit } from '@angular/core';
import {Roles} from "../shared/authentication/auth.service";

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

    private roles = Roles;
    constructor() { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/layout/layout.component.ts